import { createSelector } from '@reduxjs/toolkit';

const selectHeaderState = (state: any) => state.header;

export const selectActiveTab = createSelector([selectHeaderState], (header) => header.activeTab);
